import Tabs from "../modules/tabs";

export default {
  init() {
    Tabs.init();
  },
};
